import { PublicClientApplication } from '@azure/msal-browser';
import { env } from '@sib/config';

let redirectInterceptor: ((url: string) => void) | null = null;

export const setRedirectInterceptor = (
  interceptor: ((url: string) => void) | null
) => {
  redirectInterceptor = interceptor;
};

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: env.azureClientId || '',
    authority: `https://login.microsoftonline.com/${env.azureTenantId}`,
    redirectUri: `${window.location.origin}/redirect`,
    onRedirectNavigate: url => {
      if (!redirectInterceptor) return;
      const interceptor = redirectInterceptor;
      redirectInterceptor = null;
      interceptor(url);

      return false;
    },
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    tokenRenewalOffsetSeconds: 35 * 60,
  },
});

export { msalInstance };
